/**
 * EXCHANGE RATES STORE
 */
import Vue from "vue";
import Vuex from "vuex";
import api from "Api";
import router from "Router";
import app from "Main";

// import the api endpoints
import {
    getExchangeRates,
    getExchangeRate,
    printExchangeRate,
    createExchangeRates,
    updateExchangeRates,
    deleteExchangeRates,
    getApiLayer,
} from "Core/configuration/currencies/config/api.exchange_rates";

const state = {
    page: {},
    form: {},
    exchange_rates: [],
    selectedExchangeRate: {
        exchange_rate_id: null,
        company_id: "",
        exchange_rate_date: "",
        reference_number: "",
        status_id: "",
        billing_address_id: "",
        shipping_address_id: "",
        comments: "",
        exchange_rate_details: [],
    },
    exchange_rates_filter: {
        search: "",
        is_active: "1",
        page_size: 2,
        page_num: 1,
    },
    rules_exchange_rates: {
        exchange_rate_id: {
            name: "exchange_rate_id",
            rules: "trim|max_length[15]|integer",
            max_len: "15",
            min_len: "",
            default_value: "",
        },
        from_currency_id: {
            name: "from_currency_id",
            rules: "trim|max_length[15]|integer|required",
            max_len: "15",
            min_len: "",
            default_value: "",
        },
        to_currency_id: {
            name: "to_currency_id",
            rules: "trim|max_length[15]|integer|required",
            max_len: "15",
            min_len: "",
            default_value: "",
        },
        rate: {
            name: "rate",
            rules: "trim|max_length[19]|decimal|required",
            max_len: "18",
            min_len: "",
            default_value: "",
        },
    },
};

// getters
const getters = {
    exchange_rates: (state) => {
        return state.exchange_rates;
    },
};

// actions
const actions = {
    async fetchExchangeRates({ rootState, commit, dispatch }, payload = null) {
        try {
            let body = payload.body ? payload.body : "";
            let config = {
                headers: payload.headers ? payload.headers : {},
            };

            const response = await getExchangeRates({ body: body, headers: config.headers });

            if (typeof response !== "undefined" && response.data) {
                if (response.data.page) {
                    commit("setPageExchangeRates", response.data.page);
                }

                commit("setExchangeRates", response.data.exchange_rates);

                return response.data;
            } else {
                console.log("fetch all response error");
                return;
            }
        } catch (error) {
            console.log("fetch all error");
            return;
        }
    },
    async fetchApiLayer({ rootState, commit, dispatch }) {
        try {
            const response = await getApiLayer();

            if (typeof response !== "undefined" && response.data) {
                return response.data;
            } else {
                console.log("fetch api layer response error");
                return;
            }
        } catch (error) {
            console.log("fetch api layer error");
            return;
        }
    },
    async fetchExchangeRate({ rootState, commit, dispatch }, payload = null) {
        try {
            let response = null;
            let body = payload.body ? payload.body : "";
            let config = {
                headers: payload.headers ? payload.headers : {},
            };

            response = await getExchangeRate(payload.id);

            if (typeof response !== "undefined" && response.data) {
                commit("setSelectedExchangeRate", response.data.exchange_rate);
                return response.data;
            } else {
                console.log("fetch response error");
                return;
            }
        } catch (error) {
            console.log("fetch single error");
            return;
        }
    },
    async printExchangeRate({ rootState, commit, dispatch }, payload = null) {
        try {
            let response = null;
            let config = {
                headers: payload.headers ? payload.headers : {},
            };

            response = await printExchangeRate(payload.id);

            if (typeof response !== "undefined" && response.data) {
                return response.data;
            } else {
                console.log("fetch print response error");
                return;
            }
        } catch (error) {
            console.log("print error");
            return;
        }
    },
    async saveExchangeRate({ rootState, commit, dispatch }, payload) {
        try {
            let response = null;
            let body = payload.body;
            let config = {
                headers: payload.headers ? payload.headers : {},
            };

            if (typeof body["exchange_rate_id"] === "undefined" || body["exchange_rate_id"] == null || body["exchange_rate_id"] == "") {
                delete body["exchange_rate_id"];
                response = await createExchangeRates({ body: body, headers: config.headers });
            } else {
                let exchange_rate_id = body["exchange_rate_id"];
                delete body["exchange_rate_id"];
                response = await updateExchangeRates({ body: body, headers: config.headers }, exchange_rate_id);
            }

            if (typeof response !== "undefined" && response.data) {
                return response.data;
            } else {
                console.log("save response error");
                return;
            }
        } catch (error) {
            console.log("save error");
            return;
        }
    },
    async deleteExchangeRate({ rootState, commit, dispatch }, payload) {
        try {
            let response = null;
            let body = payload.body;
            let config = {
                headers: payload.headers ? payload.headers : {},
            };

            response = await deleteExchangeRates(payload.id);

            if (typeof response !== "undefined" && response.data) {
                return response.data;
            } else {
                console.log("delete response error");
                return;
            }
        } catch (error) {
            console.log("delete error");
            return;
        }
    },
};

// mutations
const mutations = {
    setPageExchangeRates(state, page) {
        state.page = page;
    },
    setExchangeRates(state, exchange_rates) {
        state.exchange_rates = exchange_rates;
    },
    setSelectedExchangeRate(state, exchange_rate) {
        state.selectedExchangeRate = exchange_rate;
    },
    resetSelectedExchangeRate(state) {
        for (const key in state.selectedExchangeRate) {
            if (key in state.rules_exchange_rates) {
                state.selectedExchangeRate[key] =
                    state.rules_exchange_rates[key].default_value == "null" ? null : state.rules_exchange_rates[key].default_value;
            }
        }
    },
};

export default {
    state,
    getters,
    actions,
    mutations,
};
